import React from 'react';
import './about.css';

const About = () => {
    return (
        <div id="about" className="about">

            <section class="philosophy">
                <h2>Philosophie</h2>
                <p>
                    Il faut employer le bon matériau au bon endroit. <br />Le succès d’un projet réside dans une conception réfléchie et une bonne coordination des différents corps de métier.
                </p>
            </section>
            <section class="timeline">
                <h2>Parcours Professionnel</h2>
                <div class="timeline-container">
                <div class="timeline-item">
                    <div class="timeline-content">
                        <div class="date">2019</div>
                        <h3>Obtention du diplôme d’ingénieur industriel orientation construction à la HEPL.</h3>
                    </div>
                </div>

                <div class="timeline-item">
                    <div class="timeline-content">
                        <h3>Employé de bureau d’étude</h3>
                        <div>
                            <p>Etude et conception d’ouvrages (ouvrages d’art, bâtiments industriels, structures béton et acier)<br />
                                Assistance à la maitrise d’œuvre<br />
                                Pilotage et coordination des travaux<br />
                                Assistance technique
                            </p>
                        </div>
                        <div class="date">2019 – 2023</div>
                    </div>
                </div>

                <div class="timeline-item">
                    <div class="timeline-content">
                        <h3>Ingénieur structure bois</h3>
                        <p>Etude et conception de structures en bois (Maisons unifamiliales en CLT, Bâtiments industriels en Lamellé collé)<br />
                            Assistance technique</p>
                        <div class="date">2023 - 2025</div>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="timeline-content">
                        <div class="date">2025</div>
                        <h3>Ouverture du bureau d’étude D-BE</h3>
                    </div>
                </div>
                </div>
            </section>



        </div>
    );
};

export default About;
